import { BaseUseCase } from "../UseCaseBase";
class MarketNewsUseCase extends BaseUseCase {
    constructor(repo) {
        super();
        this.repo = repo;
    }
    async fetchResult() {
        return await this.repo.getMarketNewsData();
    }
}
export default MarketNewsUseCase;
